export default __webpack_public_path__ + "assets/fcb-logo.25521501.png";